// extracted by mini-css-extract-plugin
export default {"oldFeeWrap":"QG8LP","oldFee":"n9juU","unit":"pOXoB","discountWrap":"bRVgV","discountText":"vxdhH"};